import Axios from 'axios'
const p = (path = '') => `${window.$ApiHost}/categories/${path ? path + '/' : path}`

const state = {
  items: [],
  hasItems: true,
  total: 0,
  itemsParams: {},
}
const mutations = {

  SET_ITEMS(state, { results }) {
    results.forEach(newItem => {
      const oldItem = state.items.find(e => +e.id === +newItem.id)
      const oldIndex = state.items.indexOf(oldItem)

      if (oldIndex > -1) {
        state.items[oldIndex] = newItem
      } else {
        state.items.push(newItem)
      }
    })
    state.hasItems = state.items.length < state.total
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
  ADD_COVER_PHOTO(state, data) {
    state.items.find(e => e.id === data?.category).cover_photos.push(data)
  },
  SAVE_QUERY_PARAMS_PARENT(state, params) {
    const children = state.items.filter(el => el?.parent === params.parent)
    state.itemsParams[params.parent] = { ...params }
    state.itemsParams[params.parent].hasMore = params.total > children.length && children.length > 1
  },
  DEL_COVER_PHOTO(state, id) {
    const category = state.items.find(el => el?.cover_photos?.find(e => e.id === id)?.id === id)
    category.cover_photos = category.cover_photos.filter(e => e.id !== id)
  },
}
const actions = {
  async add({ commit }, payload) {
    let response
    try {
      response = await Axios.post(p(), payload)
      commit('SET_ITEMS', { results: [response.data] })
    } catch (error) {
      response = error.response
    } finally {
    }
    return response
  },
  async coverDelPhoto({ commit }, id) {
    if (isNaN(id)) {
      throw new Error('no valid id')
    }
    let response
    try {
      response = await Axios.delete(p(`cover_photos/${id}`))
      commit('DEL_COVER_PHOTO', id)
    } catch (error) {
      response = error.response
    } finally {
    }
    return response
  },
  async get({ commit, state }, params = { }) {
    if (state.total === 0 || state.total < state.items.length) {
      const res = await Axios.get(p(), { params: { limit: 1 } })
      commit('SET_TOTAL', res.data.total_objects)
    }

    let response
    try {
      response = await Axios.get(p(), { params })
      await commit('SET_ITEMS', { ...response.data, ...params })
      if (!isNaN(params?.parent)) {
        commit('SAVE_QUERY_PARAMS_PARENT', { ...params, total: response.data?.total_objects })
      }
    } catch (error) {
      response = error.response
    } finally {
    }
    return response
  },
  async getItem({ commit }, id) {
    if (isNaN(id)) {
      throw new Error('no valid id')
    }
    let response
    try {
      response = await Axios.get(p(id))
      const { data } = response
      commit('SET_ITEMS', { results: [data] })
    } catch (error) {
      response = error.response
    } finally {
    }
    return response
  },
  async coverSetPhoto({ commit }, payload) {
    let response
    try {
      response = await Axios.post(p('cover_photos'), payload)
      commit('ADD_COVER_PHOTO', response.data)
    } catch (error) {
      response = error.response
    } finally {
    }
    return response
  },
}

const getters = {
  getCategories: state => {
    const items = JSON.parse(JSON.stringify(state.items))
    items.forEach((el) => {
      if (!Array.isArray(el.children)) el.children = []
      if (el.parent > 0) {
        const parent = items.find(elp => elp.id === el.parent)
        parent.children = [...parent?.children, el]
      }
    })
    return items.filter(el => el.parent === null)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
